"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../index"));

var _validator = _interopRequireDefault(require("./validator"));

var _EventHandler = _interopRequireDefault(require("./EventHandler"));

var _InputError = _interopRequireDefault(require("../shared/InputError"));

require("./styles.scss");

var TextFieldInput = function TextFieldInputControl(props) {
  if (props.customControlRenderer) {
    return props.customControlRenderer(props);
  }

  return defaultControlRenderer(props);
};

var defaultControlRenderer = function defaultTextInputControlRenderer(_ref) {
  var storedValue = _ref.storedValue,
      isValid = _ref.isValid,
      complete = _ref.complete,
      fieldData = _ref.fieldData,
      classPrefix = _ref.classPrefix,
      eventHandler = _ref.eventHandler;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: fieldData.id,
    className: "".concat(classPrefix, "__label")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classPrefix, "__label-text")
  }, fieldData.label)), /*#__PURE__*/_react["default"].createElement("input", {
    id: fieldData.id,
    name: fieldData.fieldKey,
    className: "".concat(classPrefix, "__input"),
    type: fieldData.control.type,
    value: storedValue,
    onChange: function onChange(event) {
      return eventHandler.onChange(event);
    },
    onBlur: function onBlur(event) {
      return eventHandler.onBlur(event);
    },
    onFocus: function onFocus() {
      return eventHandler.onFocus();
    }
  }), /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    showError: !isValid && complete,
    classPrefix: classPrefix,
    message: fieldData.validation.message
  }));
};

TextFieldInput.displayName = 'TextInputControl';
defaultControlRenderer.propTypes = {
  storedValue: _propTypes["default"].string.isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  dirty: _propTypes["default"].bool.isRequired,
  // eslint-disable-line
  complete: _propTypes["default"].bool.isRequired,
  classPrefix: _propTypes["default"].string.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func.isRequired,
    onFocus: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired
};

var _default = (0, _index["default"])(TextFieldInput, _validator["default"], _EventHandler["default"]);

exports["default"] = _default;